<template>
    <v-layout>
        <v-flex class="scroll-y pb-64">
            <text-field :label="`${$t('azioni.cerca')}...`" v-model="search" solo-inverted flat
                prepend-inner-icon="search" class="input--dense mb-2" />

            <data-table :items="reports" :headers="[
                { text: $t('label.data_invio'), value: 'data_invio', sortable: true, width: 14 },
                { text: $t('label.mittente'), value: 'email_mittente', sortable: true, width: 18 },
                { text: $t('label.destinatario'), value: 'email_destinatario', sortable: true, width: 18 },
                { text: $t('label.periodo'), value: 'periodo', sortable: true, width: 25 },
                { text: '', value: 'a', width: 10 },
                { text: '', value: 'b', width: 10 },
                { text: '', value: 'c', width: 10 }
            ]" :width-auto="true" :descending="true" :loading="loading" :search="search" @click:item="() => { }">

                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.data_invio || '-' }}</td>
                    <td>{{ item.email_mittente || '-' }}</td>
                    <td>{{ item.email_destinatario || '-' }}</td>
                    <td>{{ (item.da + " - " + item.a) || '-' }}</td>
                    <td>
                        <v-btn v-if="item.data_invio == null" @click="cancellaFile(item)"
                            style="background-color: red; color: white">
                            <v-icon>delete_outline</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-btn v-if="item.data_invio == null" @click="inviaFile(item)"
                            style="background-color: green; color: white">
                            <v-icon>send</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-btn @click="scaricaFile(item)" style="background-color: gray; color: white">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </td>
                </template>
            </data-table>

        </v-flex>
    </v-layout>
</template>

<script>
import DataTable from '@/components/base/DataTable'
export default {
    name: 'ExportReport',
    components: { DataTable },
    data: () => ({
        loading: false,
        reports: [],
        search: ''
    }),
    mounted() {
        this.fetchData()
    },
    methods: {
        fetchData() {
            this.loading = true
            this.$api.reports.getTrimestrali()
                .then(response => {
                    this.reports = response.data
                    this.loading = false
                }).catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        },
        scaricaFile(file) {
            this.loading = true;

            this.$api.reports.downloadExistentDatiMinimiExcel(file.da, file.a).then()
                .catch(e => {
                    this.$snackbar.showServerError(e)
                })

            this.loading = false;
        },
        cancellaFile(file) {
            this.$confirmDialog.show(
                { da: file.da, a: file.a, fetchFunction: this.fetchData },
                this.$t('reports.messaggi.cancella_trimestrale'),
                function ({ da, a, fetchFunction }) {
                    this.loading = true
                    this.$api.reports.cancelDatiMinimiExcel(da, a)
                        .then(() => {
                            fetchFunction();
                        }).catch(e => {
                            this.$snackbar.showServerError(e)
                        })
                    this.loading = false
                });
        },
        inviaFile(file) {
            this.$confirmDialog.show(
                { da: file.da, a: file.a, fetchFunction: this.fetchData },
                this.$t('reports.messaggi.invio_trimestrale'),
                function (params, lang) {
                    this.loading = true
                    this.$api.reports.sendMailTrimestrali(params.da, params.a, lang)
                        .then(() => {
                            this.$snackbar.show(this.$t('reports.label.email_inviata_correttamente'), 'success')
                            params.fetchFunction();
                        }).catch(e => {
                            console.log(e);
                            this.$snackbar.showServerError(e)
                        })
                    this.loading = false
                },
                {
                    showLanguageSelector: true,
                });
        }
    }
}

</script>
